import { fetchChunksWithConcurrencyLimit } from '@/common/api/chunkedFetch';
import { tempoApi } from '@/common/api/tempoApi';
import type { ItemFinancials, SetItemFinancialsInput } from '@/common/api/types/itemFinancials';
import { chunkBy } from '@/common/utils/chunkBy';

const BULK_FETCH_PAGE_SIZE_LIMIT = 100;

const fetchBatch = async (itemIds: number[], signal?: AbortSignal): Promise<ItemFinancials[]> => {
  const { financials } = await tempoApi()
    .post('api/v1/item-store/item-financials/bulk-fetch', { json: { itemIds }, signal })
    .json<{ financials: ItemFinancials[] }>();
  return financials;
};

const bulkGetItemFinancials = async (
  itemIds: number[],
  signal?: AbortSignal,
): Promise<ItemFinancials[]> => {
  if (itemIds.length === 0) return [];
  if (itemIds.length <= BULK_FETCH_PAGE_SIZE_LIMIT) return fetchBatch(itemIds, signal);

  const batches = await fetchChunksWithConcurrencyLimit(
    chunkBy(itemIds, BULK_FETCH_PAGE_SIZE_LIMIT),
    (batch) => fetchBatch(batch, signal),
  );
  return batches.flat();
};

const setItemFinancials = async (
  itemId: number,
  input: SetItemFinancialsInput,
): Promise<ItemFinancials> => {
  return await tempoApi()
    .put(`api/v1/item-store/item-financials/${itemId}`, { json: input })
    .json<ItemFinancials>();
};

export const ItemFinancialsApi = {
  bulkGetItemFinancials,
  setItemFinancials,
} as const;
